
import {
  defineComponent, ref, Ref, computed,
} from 'vue';
import { PHOTO_VIEW_TYPE, SHARE_ACCESS } from '@/types/enums';
import { IGroup, IRequestSpacesContact } from '@/types/interfaces';
import BottomPopUpItemWrapper from '../../BottomPopUpItemWrapper.vue';
import BottomPopUpItem from '@/components/BottomPopUp/BottomPopUpItem.vue';
import { lowResUrlByViewTypeByUrl } from '@/helpers/lowResPhotoUrl';
import AppSearch from '@/components/UI/AppSearch.vue';

export default defineComponent({
  components: {
    BottomPopUpItemWrapper,
    BottomPopUpItem,
    AppSearch,
  },
  props: {
    type: { type: String as () => SHARE_ACCESS, required: true },
    contactList: { type: Array as () => IRequestSpacesContact[], required: true },
    groupList: { type: Array as () => IGroup[], required: true },
  },
  emits: ['back', 'onSelect', 'done'],
  setup(props, { emit }) {
    const search: Ref<string> = ref('');

    function onSelectGroup(group: IGroup) {
      emit('onSelect', { data: group, type: props.type });
    }

    function onSelectContact(contact: IRequestSpacesContact) {
      emit('onSelect', { data: contact, type: props.type });
    }

    function resolveFullName(contact: IRequestSpacesContact): string {
      return `${contact.user.firstName} ${contact.user.lastName}`;
    }

    function resolveGroupPhotoUrl(group: IGroup): string {
      if (group.photo?.url) {
        return lowResUrlByViewTypeByUrl(group.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/Group.svg');
    }

    function resolveContactPhotoUrl(contact: IRequestSpacesContact): string {
      if (contact.user.photo?.url) {
        return lowResUrlByViewTypeByUrl(contact.user.photo.url, PHOTO_VIEW_TYPE.WHSML);
      }
      // eslint-disable-next-line global-require
      return require('@/assets/img/mockup/profile.svg');
    }

    const filterGroups = computed(() => props.groupList.filter((gr) => gr.name.toLowerCase().includes(search.value.toLowerCase())));
    const filterContacts = computed(() => props.contactList.filter((ct) => resolveFullName(ct).toLowerCase().includes(search.value.toLowerCase())));

    return {
      search,
      filterGroups,
      filterContacts,
      onSelectGroup,
      onSelectContact,
      resolveFullName,
      resolveGroupPhotoUrl,
      resolveContactPhotoUrl,
      SHARE_ACCESS,
    };
  },
});

